import {
  RouteConfig
} from 'vue-router'
import Layout from '@/layout/index.vue'

const projectRouter: RouteConfig = {
  path: '/report',
  component: Layout,
  redirect: '/report/shopReport',
  name: '报表',
  meta: {
    title: '报表'
  },
  children: [{
    path: 'shopReport',
    name: 'shopReport',
    component: () => import(/* webpackChunkName: "report-store" */'@/views/report/shopReport.vue'),
    meta: {
      title: '门店利润表'
    }
  },
  {
    path: 'shopSaleReport',
    name: 'shopSaleReport',
    component: () => import(/* webpackChunkName: "report-store" */'@/views/report/storeIncomeReport.vue'),
    meta: {
      title: '门店销售表'
    }
  },
  {
    path: 'shopCardSaleReport',
    name: 'shopCardSaleReport',
    component: () => import(/* webpackChunkName: "report-store" */'@/views/report/storeCardSaleYearlyReport.vue'),
    meta: {
      title: '门店会员卡销售表'
    }
  },
  {
    path: 'splitAccountReport',
    name: 'splitAccountReport',
    component: () => import(/* webpackChunkName: "report-store" */'@/views/report/StoreSplitAccountReport.vue'),
    meta: {
      title: '门店分账报表',
    }
  },
  {
    path: 'partialAreaReport',
    name: 'partialAreaReport',
    component: () => import(/* webpackChunkName: "report-partial-area" */'@/views/report/partialAreaReport.vue'),
    meta: {
      title: '片区利润表'
    }
  },
  {
    path: 'bigAreaReport',
    name: 'bigAreaReport',
    component: () => import(/* webpackChunkName: "report-big-area" */'@/views/report/bigAreaReport.vue'),
    meta: {
      title: '大区利润表'
    }
  },
  {
    path: 'headquartersReport',
    name: 'headquartersReport',
    component: () => import(/* webpackChunkName: "report-headquarters" */'@/views/report/headquartersReport.vue'),
    meta: {
      title: '总部利润表'
    }
  },
  {
    path: 'cardDetailReport',
    name: 'cardDetailReport',
    component: () => import(/* webpackChunkName: "report-card-detail" */'@/views/report/cardDetailReport.vue'),
    meta: {
      title: '会员卡明细表'
    }
  }
  ]
}

export default projectRouter
